import React from 'react';
import Tag from './Tag';

const FloatingLabelTagsWrapper = ({ label, tags, onTagRemove, name, isInvalid = false ,
                                      id = "id" , formatter, tooltipFormatter,
                                      labelSeparator = " ", labelKeys = [["name"]], disabled,
                                      disabledFor = (e) => false}) => {

    const displayLabel = (tag) => {
        if (formatter) {
            return formatter(tag);
        } else {
            return labelKeys.map((key) => tag[key]).join(labelSeparator ?? " ");
        }
    }
    const displayTooltip = (tag) => {
        if (tooltipFormatter) {
            return tooltipFormatter(tag);
        } else {
            return null;
        }
    }

    const disabledWhen = (tag) => {
        if (disabledFor) {
            return disabledFor(tag);
        }
        return false;
    }

    return (
        <label className={"field has-float-label loadable " }>
            <div className="card is-tags is-shadowless tags" >
                {tags && tags.map((tag, index) => (
                    <div key={`selected-${index}`} className="">
                        <Tag
                            key={"tag_" + index + "_" + tag[id] }
                            icon="fz fz-eraser"
                            className=" m-2 is-family-secondary is-medium is-selectable"
                            onClick={() => onTagRemove(tag)}
                            label={displayLabel(tag)}
                            tooltip={displayTooltip(tag)}
                            disabled={disabled || disabledWhen(tag) }
                        />
                    </div>
                ))}
            </div>
            <span>{label}</span>

        </label>
)
    ;
};

export default FloatingLabelTagsWrapper;
